import InputType from "common/form/InputType";
import { Form, Input } from "decorator-form";

@Form({title: "Organization Bundle Entry List Panel Config"})
export class Config {

	@Input({type: InputType.CHECKBOX, title: "Enable Refine"})
	public enableRefine?: boolean;

	@Input({type: InputType.NUMBER, title: "Page Size"})
	public pageSize?: number;

}



// WEBPACK FOOTER //
// ./src/panels/organizationAdmin/BundleEntryListConfig.ts